(function (angular) {
    'use strict';

    angular.module('app.landing').controller('app.landing.locationModalController', [
        '$uibModalInstance',
        '$scope',
        '$state',
        '$location',
        'supportService',
        'app.purchase.purchaseFlowService',
        'ui',
        '$timeout',
        '$cookies',
        '$rootScope',
        function (
            $uibModalInstance,
            $scope,
            $state,
            $location,
            supportService,
            purchaseFlowService,
            ui,
            $timeout,
            $cookies,
            $rootScope
        ) {
            var vm = this;
            var geocoder;
            var planStartDateStatus;
            vm.googleStateAbbrev = '';
            vm.close = close;
            vm.timeMessage = '';
            vm.isLocationConfirmPage = true;
            vm.isWashingtonModal = false;
            vm.isLocationOff = false;
            vm.states = supportService.getStates();
            vm.selectedState = '';

            vm.confirmState = confirmState;
            vm.chooseState = chooseState;
            vm.confirmSelectedState = confirmSelectedState;
            vm.cancelSelectedState = cancelSelectedState;
            vm.resetErrorOnChange = resetErrorOnChange;
            vm.backToSelector = backToSelector;
            vm.isInvalidState = false;
            vm.ccpaModalOpen = $rootScope.ccpaModalOpen;

            vm.acceptCcpaPopUp = acceptCcpaPopUp;
            vm.closeModalGetTempCookie = closeModalGetTempCookie;

            initialize();

            function acceptCcpaPopUp() {
                //save the cookies
                var now = new window.Date(),
                    // this will set the expiration to 12 months
                    exp = new window.Date(now.getFullYear(), now.getMonth() + 12, now.getDate());
                $cookies.put(environment.ccpaCookieName, true, {
                    expires: exp
                });

                $rootScope.ccpaModalOpen = false;
                vm.ccpaModalOpen = $rootScope.ccpaModalOpen;
            }

            function closeModalGetTempCookie() {
                $cookies.put(environment.ccpaCookieName, true);
                $rootScope.ccpaModalOpen = false;
                vm.ccpaModalOpen = $rootScope.ccpaModalOpen;
            }

            function initialize() {
                geocoder = new google.maps.Geocoder();
                geolocate();
                getTime();
            }

            function getTime() {
                var today = new Date();
                var curHr = today.getHours();

                if (curHr < 12) {
                    vm.timeMessage = 'Good Morning';
                } else if (curHr < 18) {
                    vm.timeMessage = 'Good Afternoon';
                } else {
                    vm.timeMessage = 'Good Evening';
                }
            }

            function resetErrorOnChange() {
                vm.isInvalidState = false;
            }

            function geolocate() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        $scope.position = position;
                        var lat = position.coords.latitude;
                        var lng = position.coords.longitude;
                        codeLatLng(lat, lng);
                    }, getStateError);
                } else {
                    vm.isLocationConfirmPage = false;
                    vm.isLocationOff = true;
                }
            }

            function chooseState() {
                // change to choose state form.
                vm.isLocationConfirmPage = false;
                vm.isLocationOff = false;
            }

            function getStateError() {
                $timeout(function () {
                    vm.isLocationConfirmPage = false;
                    vm.isLocationOff = true;
                }, 50);
            }

            function codeLatLng(lat, lng) {
                var latlng = new google.maps.LatLng(lat, lng);
                geocoder.geocode({ latLng: latlng }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        if (results[1]) {
                            var arrAddress = results;
                            $.each(arrAddress, function (i, address_component) {
                                if (address_component.types[0] == 'administrative_area_level_1') {
                                    $timeout(function () {
                                        vm.googleState = address_component.address_components[0].long_name;
                                    }, 50);
                                    vm.googleStateAbbrev = address_component.address_components[0].short_name;
                                }
                            });
                        } else {
                            console.log('No results found');
                        }
                    } else {
                        console.log('Geocoder failed due to: ' + status);
                        vm.isLocationConfirmPage = false;
                        vm.isLocationOff = true;
                    }
                });
            }

            function isValidState(abbrev) {
                var status = false;
                if ($rootScope.supportedStates.includes(abbrev)) {
                    status = true;
                } else {
                    status = false;
                }

                return status;
            }

            function getStateAbbreviation(fullName) {
                var stateAbbrev = vm.states.find(function (e) {
                    return e.name == fullName;
                });
                return stateAbbrev.abbr;
            }

            function confirmState() {
                // use the abbrev state name below
                $rootScope.currentState = vm.googleStateAbbrev;

                if ($rootScope.currentState === 'CA') {
                    getPlanStartDateStatus('Smile Generation Dental Plan CA 2024');
                } else {
                    getPlanStartDateStatus('Smile Generation Dental Plan 2024');
                }

                //updateSiteContentByState(vm.googleStateAbbrev, false);
            }

            function confirmSelectedState(locationForm) {
                var abbrev = getStateAbbreviation(vm.selectedState);
                $rootScope.currentState = abbrev;

                if ($rootScope.currentState === 'CA') {
                    getPlanStartDateStatus('Smile Generation Dental Plan CA 2024');
                } else {
                    getPlanStartDateStatus('Smile Generation Dental Plan 2024');
                }
                //updateSiteContentByState(abbrev, false);
            }

            function cancelSelectedState(locationForm) {
                // send selected state.
                locationForm.$setUntouched();
                vm.isInvalidState = false;
                vm.selectedState = '';
            }

            function close(value) {
                $uibModalInstance.close(value);
            }

            function backToSelector() {
                vm.isWashingtonModal = false;
                vm.isInvalidState = false;
                vm.selectedState = '';
            }

            function getPlanStartDateStatus(plan) {
                purchaseFlowService.getPlanStartDate(plan).then(function (result) {
                    if (result.planStatus === true) {
                        planStartDateStatus = true;
                    } else {
                        planStartDateStatus = false;
                    }
                    updateSiteContentByState($rootScope.currentState, false);
                });
            }
            function updateSiteContentByState(state, isNotClose) {
                if (isValidState(state)) {
                    vm.isInvalidState = false;
                } else {
                    vm.isInvalidState = true;
                    return;
                }

                var stateObj = vm.states.find(function (e) {
                    return e.abbr === state;
                });

                var stateName = stateObj ? stateObj.name : null;

                var exp = new Date();
                exp.setFullYear(exp.getFullYear() + 100);

                $cookies.put('stateValue', stateName, { expires: exp });

                var provider = 'Wellfit';
                var company = 'Wellfit Plan';
                var companyAccepted = 'Smile Generation';
                var planNamePrefix = 'Smile Generation Dental Plan 2023';
                var planNameBasic = 'Smile Generation Dental Plan';
                var planName = 'Smile Generation Dental Plan<sup>®</sup>';
                var planNamePlural = 'Smile Generation Dental Plans<sup>®</sup>';
                var planFileName = 'SmileGenerationDentalPlan';
                var planNameShort = 'Smile_Generation';
                var planAcronym = 'sgdp';
                var planAcronymLabel = 'SGDP';
                var planPhoneNumber = '(833) 333-7437';
                var planPhoneNumberBasic = '8333337437';
                var planEmail = 'SGDPsupport@smilehealthdentalplans.com';
                var planAdmin = 'Wellfit Plans, LLC';
                var planAdminPhone = '(855) 935-5365';
                var organizationId = '5068093D-AA1F-41F8-AC42-1FC85A92B766';
                var careingtonTextShow = false;
                var cancellationText =
                    'The cancellation and refund policy can be found in the Membership Agreement under Section 9.';
                var servicesRight =
                    '<div class="header">More Benefits For You</div><div class="body">In addition to discounts on general dentistry, there are even more great benefits for ' +
                    planName +
                    ' members including:<ul class="body list-item"><li>20%-60% savings on Mouth-Body Connection<sup>®</sup> procedures like oral cancer screenings, salivary lab tests and full-mouth periodontal treatment</li><li>20% discounts on specialty care such as gum (periodontal) treatment, oral surgery, orthodontics, root canal treatment, cosmetic services like in-office teeth whitening and more</li><li>Additional benefits for members with underlying health conditions</li></ul></div>';
                var planFootNote = '*Price includes a one-time, non-refundable $15 administration fee.';
                var savingsText =
                    'The Smile Generation Dental Plan<sup>®</sup> is designed to help you during these times by offering significant discounts on the dentistry you need. Benefits include: <br /><ul class="body savings-list"><li>Save 20% - 50% on most dental procedures</li><li>$0 teledentistry / virtual consultations</li><li>$0 dental exams and X-rays</li><li>Since this is not insurance, there are no deductibles or annual maximums</li><li>Same-day discounts on dentistry—no waiting</li></ul>';
                var choosePlanInfo =
                    '<h5 class="all-plans-header">All Plans include:</h5><ul class="choose-plan-benefits-list"><li>Save 20% - 50% on most dental procedures</li><li>$0 teledentistry / virtual consultations</li><li>$0 dental exams and X-rays</li><li>Since this is not insurance, there are no deductibles or annual maximums</li><li>Same-day discounts on dentistry—no waiting</li></ul>';
                var footerText = [
                    "<h4 style='font-weight: 700'>" +
                        planName +
                        ' is NOT insurance and is not intended to replace health insurance.</h4>',
                    'The plan does not pay providers directly. Members must pay for services at the time of treatment and will receive discounted rates from participating providers listed at SmileGenerationDentalPlan.com. Discounted rates may vary depending on the type of provider and service. You may cancel within the first 30 days after payment and receive a refund of your annual fees, except the $15 non-refundable application fee. (Application fee is refundable for AR, LA, FL. MD receives a $10 refund). ' +
                        'If you received services under the plan prior to cancellation, you may be responsible for paying your provider the difference between the discounted rated and your provider’s standard rates for the services performed (excluding LA residents). If your plan expires and you later decide to renew, another $15 non-refundable application fee may apply. Wellfit Plans, LLC is located at 3900 Teleport Blvd., PO Box 140309, Irving, TX 75014-0309 and can be reached at 833-333-7437.'
                ];
                var discountPricing = [
                    ['Teledentistry/virtual consultation', '$258', '$0', '$258'],
                    ['Routine or emergency exam', '$135', '$0', '$135'],
                    ['Full-mouth X-ray', '$78', '$0', '$78'],
                    ['CEREC<sup>®</sup> CAD/CAM crown', '$2,100', '$1,135', '$965'],
                    [
                        'Full-mouth periodontal treatment <span class="smaller-text">(Scaling & Root Planing, Irrigation, and Bacterial Decontamination) <span>',
                        '$2,288',
                        '$1,164',
                        '$1,124'
                    ],
                    [
                        'Root canal <span class="smaller-text">(1-3 root procedure, including pulpotomy)<span>',
                        '$1,510',
                        '$1,173',
                        '$337'
                    ]
                ];
                var footnotes = [
                    '†80th percentile of an average Usual and Customary fee based on Fair Health data for participating offices. ††Average plan fee for participating offices. ¶Sample savings reflected are an average.'
                ];
                var careingtonTermsAndConditionsShow = false;

                //if the 2024 plan is active
                if (planStartDateStatus) {
                    if ($rootScope.currentState === 'CA') {
                        planNameBasic = 'Smile Generation Dental Plan CA 2024';
                        planNamePrefix = 'Smile Generation Dental Plan CA 2024';
                    } else {
                        planNameBasic = 'Smile Generation Dental Plan 2024';
                        planNamePrefix = 'Smile Generation Dental Plan 2024';
                    }
                } else {
                    if ($rootScope.currentState === 'CA') {
                        planNameBasic = 'Smile Generation Dental Plan CA 2023';
                        planNamePrefix = 'Smile Generation Dental Plan CA 2023';
                    } else {
                        planNameBasic = 'Smile Generation Dental Plan 2023';
                        planNamePrefix = 'Smile Generation Dental Plan 2023';
                    }
                }

                if (state === 'CA') {
                    provider = 'California';
                    planAdmin = 'Careington International Corporation';
                    planAdminPhone = '(833) 330-7209';
                    planPhoneNumber = '(833) 330-7209';
                    planPhoneNumberBasic = '8333307209';
                    careingtonTextShow = true;
                    careingtonTermsAndConditionsShow = true;
                    cancellationText = 'The cancellation and refund policy can be found in the Membership Agreement.';
                    servicesRight =
                        '<div class="header">More Benefits For You</div><div class="body">In addition to discounts on general dentistry, there are even more great benefits for ' +
                        planName +
                        ' members including:<ul class="body list-item"><li>20-60% savings on Mouth-Body Connection<sup>®</sup> procedures like oral cancer screenings, salivary lab tests and full-mouth periodontal treatment</li><li>20% discounts on specialty care such as gum (periodontal) treatment, oral surgery, orthodontics, root canal treatment, cosmetic services like in-office teeth whitening and more</li><li>Additional benefits for members with underlying health conditions</li></ul></div>';
                    planFootNote = '*Price includes a one-time, non-refundable $15 administration fee.';
                    savingsText =
                        'The Smile Generation Dental Plan<sup>®</sup> is designed to help you during these times by offering significant discounts on the dentistry you need. Benefits include: <br /><ul class="body savings-list"><li>Save 20% - 50% on most dental procedures</li><li>Since this is not insurance, there are no deductibles or annual maximums</li><li>Same-day discounts on dentistry—no waiting</li></ul>';
                    choosePlanInfo =
                        '<h5 class="all-plans-header">All Plans include:</h5><ul class="choose-plan-benefits-list"><li>Save 20% - 50% on most dental procedures</li><li>Since this is not insurance, there are no deductibles or annual maximums</li><li>Same-day discounts on dentistry—no waiting</li></ul>';
                    footerText = [
                        "<h4 style='font-weight: 700'>THIS PLAN IS NOT INSURANCE and is not intended to replace health insurance.</h4>",
                        'This plan does not meet the minimum creditable coverage requirements under M.G.L. c.111M and 956 CMR 5.00. This plan is not a Qualified Health Plan under the Affordable Care Act.  This is not a Medicare prescription drug plan. The range of discounts will vary depending on the type of provider and service. The plan does not pay providers directly. Plan members must pay for all services but will receive a discount from participating providers. The list of participating providers is at www.smilegenerationdentalplan.com. A written list of participating providers is available upon request.  You may cancel within the first 30 days after effective date or receipt of membership materials (whichever is later) and receive a full refund, less a nominal processing fee (nominal fee for MD residents is $5, AR residents will be refunded the processing fee). Discount Plan Organization and administrator: Careington International Corporation, 7400 Gaylord Parkway, Frisco, TX 75034; phone 800-441-0380. ' +
                            '<br>This plan is not available in Vermont or Washington.'
                    ];
                    discountPricing = [
                        ['Teledentistry/virtual consultation', '$258', '$7', '$251'],
                        ['Routine or emergency exam', '$135', '$7', '$128'],
                        ['Full-mouth X-ray', '$70', '$3', '$67'],
                        ['CEREC<sup>®</sup> CAD/CAM crown', '$2,100', '$1,195', '$905'],
                        [
                            'Full-mouth periodontal treatment <span class="smaller-text">(Scaling & Root Planing, Irrigation, and Bacterial Decontamination) <span>',
                            '$2,200',
                            '$1,300',
                            '$905'
                        ],
                        [
                            'Root canal <span class="smaller-text">(1-3 root procedure, including pulpotomy)<span>',
                            '$1,747',
                            '$1,285',
                            '$462'
                        ]
                    ];
                }

                if (state === 'WA') {
                    planAdmin = 'Careington International Corporation';
                    provider = 'Washington';
                    planNamePrefix = 'Smile Generation Dental Plan WA 2023';
                    planNameBasic = 'Smile Generation Dental Plan WA 2023';
                    careingtonTermsAndConditionsShow = true;
                    savingsText =
                        'The Smile Generation Dental Plan<sup>®</sup> is designed to help you during these times by offering significant discounts on the dentistry you need. Benefits include: <br /><ul class="body savings-list"><li>Save 20% - 50% on most dental procedures</li><li>Since this is not insurance, there are no deductibles or annual maximums</li><li>Same-day discounts on dentistry—no waiting</li><li>$0 teledentistry / virtual consultations</li><li>$0 dental exams and X-rays</li></ul>';
                    footerText = [
                        "<h4 style='font-weight: 700'>THIS PLAN IS NOT INSURANCE and is not intended to replace health insurance.</h4>",
                        'This plan does not meet the minimum creditable coverage requirements under M.G.L. c.111M and 956 CMR 5.00. This plan is not a Qualified Health Plan under the Affordable Care Act. The range of discounts will vary depending on the type of provider and service. The plan does not pay providers directly. Plan members must pay for all services but will receive a discount from participating providers. The list of participating providers is at smilegenerationdentalplan.com for dental providers.',
                        'A written list of participating providers is available upon request. You may cancel within the first 30 days after effective date or receipt of membership materials (whichever is later) and receive a full refund, less a nominal processing fee (nominal fee for MD residents is $5, AR residents will be refunded processing fee). Discount Plan Organization and Administrator: Careington International Corporation, 7400 Gaylord Parkway, Frisco, TX 75034; phone 800-441-0380.',
                        '<br>This plan is not available in Vermont.'
                    ];
                    choosePlanInfo =
                        '<h5 class="all-plans-header">All Plans include:</h5><ul class="choose-plan-benefits-list"><li>Save 20% - 50% on most dental procedures</li><li>Since this is not insurance, there are no deductibles or annual maximums</li><li>Same-day discounts on dentistry—no waiting</li><li>$0 tele-dentistry/virtual consultations</li><li>$0 dental exams and x-rays</li></ul>';
                    discountPricing = [
                        ['Teledentistry/virtual consultation', '$240', '$0', '$240'],
                        ['Routine or emergency exam', '$107', '$0', '$107'],
                        ['Full-mouth X-ray', '$179', '$0', '$179'],
                        ['CEREC<sup>®</sup> CAD/CAM crown', '$2,022', '$1004', '$1,018'],
                        ['Full-mouth periodontal treatment', '$2,160', '$924', '$1,236'],
                        [
                            'Root canal <span class="smaller-text">(1-3 root procedure, including pulpotomy)<span>',
                            '$1,147',
                            '$899',
                            '$248'
                        ]
                    ];
                }

                var updatedContent = {
                    'currentState': $rootScope.currentState,
                    'theme': planAcronym,
                    'plan': planNameBasic,
                    'planNamePrefix': planNamePrefix,
                    'planPhoneNumber': planPhoneNumber,
                    'planPhoneNumberBasic': planPhoneNumberBasic,
                    'planNameShort': planNameShort,
                    'organizationId': organizationId,
                    'planOptions': [],
                    'copyright': {
                        'planName': planName,
                        'address': 'Irving, TX, USA',
                        'links': [
                            { 'text': 'Site Map', 'link': '/#/sitemap', 'target': '_self' },
                            { 'text': 'Terms of Service', 'link': '/#/terms-of-service', 'target': '_blank' },
                            { 'text': 'Privacy Policy', 'link': '/#/privacy-policy', 'target': '_blank' }
                        ]
                    },
                    'supportedStates': [],
                    'careingtonStates': ['California', 'Washington'],
                    'site': {
                        'header': {
                            'logo': '/assets/' + planAcronym + '/images/logo.svg',
                            'vineTitle': 'Adminstered by <br />' +  planAdmin + ' <br />' + planAdminPhone,
                            'links': {
                                'inviteAFriend': true,
                                'support': true,
                                'memberLogin': true,
                                'directory': true,
                                'displayVineDentalInfo': true
                            }
                        },
                        'footer': {
                            'logo': '/assets/' + planAcronym + '/images/logo-white.svg',
                            'logoTitle': planNameBasic,
                            'texts': footerText,
                            'footnotes': footnotes
                        },
                        'pages': {
                            'contactForm': {
                                'subTitle': "Have questions? <br> We'd love to help you.",
                                'phone': planPhoneNumber,
                                'times': [''],
                                'email': {
                                    'text': planEmail,
                                    'link': 'mailto:' + planEmail + '?Subject=Contact%20Us,%20Request%20from%20Wellfit'
                                }
                            },
                            'welcome': {
                                'hero': {
                                    'image': '/assets/' + planAcronym + '/images/welcome/hero.png',
                                    'title': "Just keep smiling. We'll help.",
                                    'subTitle': 'A discount dental plan designed to help you save and stay healthy.',
                                    'button': {
                                        'text': 'Start Saving Today',
                                        'link': '#/plans',
                                        'target': '_self'
                                    },
                                    'disclaimer': ''
                                },
                                'discounts': {
                                    'left': {
                                        'show': true,
                                        'title': 'See what you can save today.',
                                        'text': savingsText,
                                        'button': {
                                            'text': 'View Savings',
                                            'link': '#/summary-of-discounts',
                                            'target': '_self'
                                        }
                                    },
                                    'right': {
                                        'show': true,
                                        'table': {
                                            'header': [
                                                '',
                                                'Average Fee without Plan<sup>†</sup>',
                                                'Average Fee with Plan<sup>††</sup>',
                                                'Member Savings<sup>¶</sup>'
                                            ],
                                            'rows': discountPricing
                                        }
                                    }
                                },
                                'planPrices': {
                                    'title': 'Start Saving on the Treatment You Need',
                                    'text': '',
                                    'link': '#/plans',
                                    'target': '_self',
                                    'note': planFootNote,
                                    'button': {
                                        'text': 'JOIN NOW',
                                        'link': '#/plans',
                                        'target': '_self'
                                    }
                                },
                                'services': [
                                    {
                                        'left': {
                                            'isImage': true,
                                            'value': '/assets/' + planAcronym + '/images/welcome/service.png'
                                        },
                                        'right': {
                                            'isImage': false,
                                            'value': servicesRight
                                        }
                                    },
                                    {
                                        'left': {
                                            'isImage': false,
                                            'value':
                                                '<div class="wrapper-patolus-powered-details"><div class="header">Real-Time Visibility of Benefits + Costs</div><div class="body">' +
                                                planName +
                                                ' provides you with real-time visibility to your treatment savings and costs - all on your phone. Now you can make good decisions about your oral health and be informed every step of the way.</div></div>'
                                        },
                                        'right': {
                                            'isImage': true,
                                            'value': '/assets/' + planAcronym + '/images/welcome/in-hand.png'
                                        }
                                    }
                                ],
                                'findDentist': {
                                    'text':
                                        'Accepted exclusively at ' +
                                        companyAccepted +
                                        '<sup>&reg;</sup>-trusted offices in 25 states across the US.',
                                    'button': {
                                        'text': 'FIND A DENTIST',
                                        'link': '/#/find-a-dentist',
                                        'target': '_self'
                                    }
                                }
                            },
                            'choosePlan': {
                                'title': 'Choose Your Plan',
                                'subTitle':
                                    'The ' +
                                    planName +
                                    ' provides 20-50% discounts on most dental treatments that meet your needs.',
                                'plans': {
                                    'title': '',
                                    'info': choosePlanInfo,
                                    'footNote': planFootNote,
                                    'buttonText': 'JOIN NOW'
                                },
                                'careingtonTermsAndConditions': {
                                    'show': careingtonTermsAndConditionsShow,
                                    'text':
                                        '<p><strong>Purchase and Renewal Conditions: </strong>By joining a plan for yourself or on behalf of a minor child for whom you are a parent or legal guardian, you confirm that you are at least 18 years old and you authorize Smile Generation Dental Plan to charge your credit card or checking account for the plan you have selected. By joining you indicate you have read and agree to the terms and conditions of the plan. Your plan will automatically expire 12 months to the date of purchase.  You may renew prior to the termination of your plan and avoid the $15 administration fee.  To renew your plan, you can contact Smile Generation Dental Plan at (833) 330-7209 prior to your termination date.  Your plan can also be renewed through the Member Portal or through responding to Renewal Mailers that will be sent to your address on file.</p><p><strong>Termination Conditions: </strong>Smile Generation Dental Plan and Careington reserve the right to terminate plan members from its plan for any reason, including non-payment. If Smile Generation Dental Plan terminates the plan or your membership for a reason other than non-payment, you will receive a pro-rata refund of your membership fees.</p><p><strong>Cancellation Conditions: </strong>You have the right to cancel within the first 30 days after effective date or receipt of membership materials (whichever is later) and receive a full refund, less the processing fee, if applicable. If for any reason during this time period you are dissatisfied with the plan and wish to cancel and obtain a refund, you must submit a written cancellation request. Smile Generation Dental Plan will accept cancellation requests at any time and will stop collecting membership fees in a reasonable amount of time, but no later than 30 days after receiving a cancellation notice. Please send a cancellation letter and a request for refund with your name and member ID to Smile Generation Dental Plan, PO Box 140309, Irving, TX 75014. You may also submit cancellation requests by email: support@wellfitplans.com. When you cancel, you will continue to have access to the plan for the remainder of the period for which you have paid; your membership will terminate at the end of that period. The preceding sentence does not apply to quarterly, semi-annual or annual memberships in FL and OK, where you will receive a pro-rata refund whenever you cancel.</p><p><strong>Description of Services: </strong>Please see the enclosed materials for a specific description of the programs included in your plan.</p><p><strong>Limitations, Exclusions & Exceptions: </strong>This plan is a discount plan offered by Careington. Careington is not a licensed insurer, health maintenance organization or other underwriter of health care services. No portion of any provider’s fees will be reimbursed or otherwise paid by Careington. Careington is not licensed to provide and does not provide health care services or items to individuals. You will receive discounts for services at certain health care providers who have contracted with the plan. You are obligated to pay for all health care services at the time of service. Savings are based upon the provider’s normal fees. Actual savings will vary depending upon location and specific services or products purchased. Please verify such services with each individual provider. The plan’s discounts may not be used in conjunction with any other discount plan or program. All listed or quoted prices are current prices by participating providers and subject to change without notice. Any procedures performed by a non-participating provider are not discounted. From time to time, certain providers may offer products or services to the general public at prices lower than the discounted prices available through this plan. In such event, members will be charged the lowest price. Discounts on professional services are not available where prohibited by law. This plan does not discount all procedures. Providers are subject to change without notice and services may vary in some states. It is the member’s responsibility to verify that the provider participates in the plan. At any time Careington may substitute a provider network at its sole discretion. Careington cannot guarantee the continued participation of any provider. If the provider leaves the plan, you will need to select another provider. Providers contracted by Careington are solely responsible for the professional advice and treatment rendered to members and Careington disclaims any liability with respect to such matters.</p><p><strong>Complaint Procedure: </strong>If you would like to file a complaint regarding your plan membership, you must submit your complaint in writing to: Careington International Corporation, P.O. Box 2568, Frisco, TX 75034. You have the right to request an appeal if you are dissatisfied with the complaint resolution. After completing the complaint resolution process, if you remain dissatisfied you may contact your state insurance department.</p>'
                                }
                            },
                            'support': {
                                'title': 'Support',
                                'sections': {
                                    'stateSelection': {
                                        'show': true,
                                        'text': 'Forms vary by state. Select your state to view the appropriate forms.'
                                    },
                                    'agreements': {
                                        'show': true,
                                        'title': 'Membership Agreement',
                                        'text':
                                            '<strong>' +
                                            company +
                                            's is required to provide prospective members a copy of the Membership Agreement prior to enrollment. Simply click the PDF links below to view/print the agreement or fee schedule.</strong>',
                                        'links': {
                                            'dsdLink': {
                                                'text': 'Membership Agreement',
                                                'link':
                                                    "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_" +
                                                    planNameShort +
                                                    '_' +
                                                    provider +
                                                    '.pdf',
                                                'target': '_blank'
                                            },
                                            'pfsLink': {
                                                'show': true,
                                                'text': 'Plan Fee Schedule',
                                                'link':
                                                    "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_" +
                                                    planNameShort +
                                                    "_[[STATE]].pdf'",
                                                'target': '_blank'
                                            },
                                            'gfLink': {
                                                'text': 'Grievance Form',
                                                'link': '/#/grievance?state=[[STATE]]',
                                                'target': '_self'
                                            },
                                            'stateBased': {
                                                'Arizona': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Colorado': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Georgia': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Idaho': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Kansas': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Kentucky': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Maryland': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Massachusetts': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Minnesota': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Missouri': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'New_Mexico': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'North_Carolina': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Ohio': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Tennessee': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Virginia': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Nevada': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Florida': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Oregon': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'South_Carolina': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Texas': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'California': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_[[STATE]]_2023.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Utah': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Louisiana': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                //----------------------
                                                'Oklahoma': {
                                                    'MA': [
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf'"
                                                        },
                                                        {
                                                            'text':
                                                                'Membership Agreement (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment After Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]]_2024.pdf'"
                                                        },
                                                        {
                                                            'text': 'Plan Fee Schedule (Enrollment Before Jan 1, 2024)',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                },
                                                'Washington': {
                                                    'MA': [
                                                        {
                                                            'text': 'Membership Agreement',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ],
                                                    'FS': [
                                                        {
                                                            'text': 'Plan Fee Schedule',
                                                            'link':
                                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_Smile_Generation_[[STATE]].pdf'"
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    'cancellation': {
                                        'title': 'Cancellation & Refund Policy',
                                        'text': cancellationText,
                                        'linkText': 'Membership Agreement'
                                    },
                                    'careingtonText': {
                                        'show': careingtonTextShow,
                                        'text':
                                            "For information regarding ancillary benefits including UNOA please <a data-qa='support.benefits.link' href='/#/benefit-info'>click here.</a>"
                                    },
                                    'grievances': {
                                        'title': 'Grievances Form',
                                        'text':
                                            "If you have a grievance, complete and submit the online grievance form, <button class='btn-link grievance-link' ng-click='goToGrivanceForm()'>here</button>.",
                                        'laLink': {
                                            'text':
                                                "<button class='btn-link grievance-link' ng-click='openLAGrienvencesLink()'>LA Grievance Form</button>",
                                            'link':
                                                "environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_" +
                                                planNameShort +
                                                '_' +
                                                provider +
                                                '.pdf',
                                            'target': '_blank'
                                        }
                                    },
                                    'details':
                                        '<hr class="breaker" /><div class="exclusions-and-limitations section"><p><strong>Have questions? Our plans specialists would love to help you.</strong></p><p>Our ' +
                                        planName +
                                        ' customer service team is here to support you and answer any questions you may have. Please feel free to contact us at <br><a href="tel:' +
                                        planPhoneNumberBasic +
                                        '">' +
                                        planPhoneNumber
                                }
                            },
                            'summaryDiscounts': {
                                'title': 'See all the ways you save.',
                                'showStates': true,
                                'states': [],
                                'links': {
                                    'sdf': {
                                        'text': "Your State's Most Commonly Viewed Fees ",
                                        'variableLink':
                                            "environment.blobStorageTopUrl + '/servicesanddisclosures/SDF_" +
                                            planNameShort +
                                            "_[[STATE]].pdf'"
                                    },
                                    'fe': {
                                        'text': "Your State's Full Fee Schedule ",
                                        'variableLink':
                                            "environment.blobStorageTopUrl + '/servicesanddisclosures/FS_" +
                                            planNameShort +
                                            "_[[STATE]]_2024.pdf'"
                                    }
                                },
                                'rightSection': {
                                    'image': {
                                        'show': true,
                                        'url':
                                            '/assets/' + planAcronym + '/images/summary-of-discounts/coverage-map.png'
                                    },
                                    'text':
                                        '<p>' +
                                        planName +
                                        ' is currently accepted at Smile Generation<sup>®</sup>-trusted offices in 24 states.</p>'
                                },
                                'mapColor': '#BB0E82',
                                'mapSelectedColor': '#970b68'
                            },
                            'directory': {
                                'iconColor': '5F4AFA',
                                'loadingColorPrimary': '5F4AFA',
                                'loadingColorSecondary': '645AA7'
                            }
                        },
                        'purchaseFlow': {
                            'allowPromoCode': true,
                            'staticPromoCode': '',
                            'activatePlan': {
                                'dsdLink': {
                                    'text': 'Membership Agreement',
                                    'link': '/servicesanddisclosures/DOS_DF_' + planNameShort + '_' + provider + '.pdf',
                                    'downloadAs': planAcronymLabel + ' Description of Services & Disclosures.pdf',
                                    'target': '_blank'
                                },
                                'touLink': {
                                    'text': 'Terms of Use',
                                    'link': 'print/eula?planName=' + planName + '',
                                    'downloadAs': planAcronymLabel + ' EULA.pdf',
                                    'target': '_blank',
                                    'path': '/app/site/purchase-flow/activate-plan/modals/terms-of-use.modal.html'
                                },
                                'privacyPolicyTemplate': {
                                    'path': '/app/site/purchase-flow/activate-plan/modals/privacy-policy.modal.html'
                                }
                            },
                            'activatedPlan': {
                                'dsdLink': {
                                    'text': 'Membership Agreement',
                                    'link': '/servicesanddisclosures/DOS_DF_' + planNameShort + '_[[STATE]].pdf',
                                    'downloadAs': planAcronymLabel + ' Description of Services & Disclosures.pdf',
                                    'target': '_blank'
                                },
                                'pfsLink': {
                                    'text': 'Plan Fee Schedule',
                                    'link': '/servicesanddisclosures/FS_' + planNameShort + '_[[STATE]].pdf',
                                    'downloadAs': planName + ' Fee Schedule.pdf',
                                    'target': '_blank'
                                },
                                'gfLink': {
                                    'text': 'Grievance Form',
                                    'link': '/#/grievance?state=[[STATE]]',
                                    'target': '_blank'
                                }
                            }
                        }
                    }
                };

                if (updatedContent != null) {
                    jQuery.extend(true, siteContent, updatedContent);
                }

                // Get options based on selected state
                ui.block();
                return purchaseFlowService
                    .getPlanOptionsByState()
                    .then(function (result) {
                        siteContent.planOptions = result;
                        if (!isNotClose) {
                            close(state);
                        }

                        if ($state.current.controller.indexOf('app.purchase') === 0) {
                            $state.go('app.purchase.plans');
                        }
                    })
                    .finally(function (result) {
                        ui.unblock();
                    });
            }
        }
    ]);
})(angular);
